var render, staticRenderFns
import script from "./ThgImpactSelectorOnlyCustomerAccount.vue?vue&type=script&lang=ts&"
export * from "./ThgImpactSelectorOnlyCustomerAccount.vue?vue&type=script&lang=ts&"
import style0 from "./ThgImpactSelectorOnlyCustomerAccount.vue?vue&type=style&index=0&id=66b447b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b447b9",
  null
  
)

export default component.exports